const hotspots = document.querySelectorAll('.em-interactive-map__hotspot');

hotspots.forEach((hotspot) => {
	hotspot.addEventListener('mouseenter', () => {
		hotspots.forEach((element) => {
			element.classList.remove('show-tooltip');
		});
	});
});
